import * as yup from 'yup';
import { QUICK_ADD_CLIENT_SOURCE_VALUES } from '@/app/(main)/clients/const/quickAddClientSources';
import { emailValidation, validatePhoneNumber } from '@/utils/validations';
import {
  FIRST_NAME_MAX_LENGTH,
  firstNameMaxMessage,
  LAST_NAME_MAX_LENGTH,
  middleNameMaxMessage,
  MIDDLE_NAME_MAX_LENGTH,
  lastNameMaxMessage,
} from '@/utils/validations/client-validations';

export type QuickAddClientFormValues = {
  userHasCertifiedTheInformation: boolean;
  first_name: string;
  last_name: string;
  middle_name: string;
  preferred_name: string;
  email: string;
  phone: string;
  date_of_birth: string;
  gender: string;
  source: number | null;
};

export const getQuickAddClientValidationSchema = () =>
  yup.object({
    userHasCertifiedTheInformation: yup.boolean().optional().default(false),
    first_name: yup.string().trim().required('First name is required').max(FIRST_NAME_MAX_LENGTH, firstNameMaxMessage),
    last_name: yup.string().trim().required('Last name is required').max(LAST_NAME_MAX_LENGTH, lastNameMaxMessage),
    middle_name: yup.string().trim().optional().default('').max(MIDDLE_NAME_MAX_LENGTH, middleNameMaxMessage),
    preferred_name: yup.string().trim().optional().default(''),
    email: yup
      .string()
      .trim()
      .optional()
      .default('')
      .test('is-valid-email', 'Invalid email', (value) => emailValidation(value ?? '')),
    phone: yup
      .string()
      .optional()
      .test('valid-phone-format', 'Invalid phone number', (value) => {
        if (!value) return true;
        return validatePhoneNumber(value);
      }),
    date_of_birth: yup.string().optional().default(''),
    gender: yup.string().optional().default(''),
    source: yup
      .number()
      .nullable()
      .oneOf([...QUICK_ADD_CLIENT_SOURCE_VALUES], 'Select a valid source')
      .optional()
      .default(null),
  });